import React from 'react';

const ButtonBasic  = ({className, btnText, onClick}) =>

    <button className={className} onClick={() => onClick()}>
        {btnText}
    </button>;

export default ButtonBasic;